import { Directive, HostListener } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { LanguageService } from '../services/language.service';

@Directive({
  selector: '[NumberInput]',
  standalone: false
})
export class NumberInputDirective {

  constructor(public languageService: LanguageService, private snackBar: MatSnackBar) { }

  @HostListener('keypress', ['$event']) onKeyDown(event: any) {
    const charCode = (event.which) ? event.which : event.keyCode;
    if ((charCode >= 48 && charCode <= 57) || (charCode >= 96 && charCode <= 105)) {
      return true;
    }
    return false;
  }

  @HostListener('paste', ['$event']) blockCopy(e: ClipboardEvent) {
    const clipboardData = e.clipboardData;
    const clipboardText = clipboardData?.getData('text') || '';
    if (clipboardData && !(/^\d+$/.test(clipboardText))) {
      e.preventDefault();
      this.snackBar.open(this.languageService.languageJSON.Global_NumberInput_InvalidPaste, "",
        { duration: 5000 });
    }
  }
}